import { Component, OnInit, Input } from '@angular/core';
import { ReleaseNote } from '../models/release-note';
import { ReleaseNotesService } from '../services/release-notes/release-notes.service';
import { NotificationVisibilityService } from '../services/notification-visibility/notification-visibility.service';

@Component({
    selector: 'app-user-notification',
    templateUrl: './user-notification.component.html',
    styleUrls: ['./user-notification.component.scss'],
    standalone: false
})
export class UserNotificationComponent implements OnInit {
  releaseNote: ReleaseNote;
  open = false;

  @Input() url: string;

  constructor(private releaseNoteService: ReleaseNotesService,
    private nvService: NotificationVisibilityService) { }

  ngOnInit(): void {
    this.releaseNoteService.latestReleaseNote(this.url, true).subscribe(rn => {
      this.releaseNote = rn;

      if (this.releaseNote && !this.nvService.hasSeen(this.releaseNote.id)) {
        this.open = true;
        this.nvService.setSeen(this.releaseNote.id);
      }
    });
  }
}
